



const iconStyle = { position: 'absolute', right: 0, top: "50%", transform: "translateY(-50%)" };

const Search = (props) => {
    return (
        <svg id="Search_Icon" style={iconStyle} dataname="Search Icon" xmlns="http://www.w3.org/2000/svg" width="16.706" height="16.706" viewBox="0 0 16.706 16.706">
            <g id="Group_884" dataname="Group 884">
                <g id="Ellipse_3" dataname="Ellipse 3" fill="#fff" stroke="#ffa539" strokeLinecap="round" strokeWidth="1">
                    <ellipse cx="6.72" cy="6.862" rx="6.72" ry="6.862" stroke="none" />
                    <ellipse cx="6.72" cy="6.862" rx="6.22" ry="6.362" fill="none" />
                </g>
                <path id="Path_7" dataname="Path 7" d="M0,0,3.223,3.51" transform="translate(12.777 12.49)" fill="none" stroke="#14a4c2" strokeLinecap="round" strokeWidth="1" />
            </g>
        </svg>
    )
};

export default Search